module.exports = __webpack_public_path__ + "img/content3.b3da756d.png";